import React from "react";
import { DetailItemProps } from "../../../@types";
import { useTranslate } from "../../../helpers";

export const DetailItem: React.FunctionComponent<DetailItemProps> = ({
  label,
  detail,
  mobileLabelOnly,
  suppressed = false,
}) => {
  const t = useTranslate();
  return (
    <div className="ds-u-lg-margin-top--1">
      <div
        className={`DetailItem__label${mobileLabelOnly ? " mobileOnly" : ""}`}
      >
        {label}
      </div>
      <div className="DetailItem__detail">
        {suppressed ? t("suppressed_plan_benefit") : detail}
      </div>
    </div>
  );
};

export default DetailItem;
